/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date Difference Calculator — Days Between Dates | Toolverse`)
};

const es_dd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Diferencia de Fechas — Días Entre Fechas | Toolverse`)
};

const de_dd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datumsdifferenzrechner — Tage zwischen Daten | Toolverse`)
};

const nl_dd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datumverschilcalculator — Dagen tussen datums | Toolverse`)
};

const fr_dd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculatrice de Différence de Dates — Jours Entre les Dates | Toolverse`)
};

const it_dd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore della differenza fra date — Giorni tra le date | Toolverse`)
};

const pt_br2_dd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Diferença de Datas — Dias Entre Datas | Toolverse`)
};

const pt_dd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Diferença de Datas — Dias Entre Datas | Toolverse`)
};

const ja_dd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日付差計算機 — 日付間の日数 | Toolverse`)
};

const zh_dd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日期差计算器 — 计算两个日期之间的天数 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dd_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dd_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dd_meta_title", locale)
	if (locale === "en") return en_dd_meta_title(inputs)
	if (locale === "es") return es_dd_meta_title(inputs)
	if (locale === "de") return de_dd_meta_title(inputs)
	if (locale === "nl") return nl_dd_meta_title(inputs)
	if (locale === "fr") return fr_dd_meta_title(inputs)
	if (locale === "it") return it_dd_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_dd_meta_title(inputs)
	if (locale === "pt") return pt_dd_meta_title(inputs)
	if (locale === "ja") return ja_dd_meta_title(inputs)
	return zh_dd_meta_title(inputs)
};